import React, { useState } from 'react';
import '../styles/pages/FlexPrinting.css';
import FlexPortfolio from './FlexPortfolio';
import FlexServicesSection from '../components/FlexServicesSection';
import HeroSection from '../components/HeroSection';

const FlexPrinting = () => {
  const [activeSection, setActiveSection] = useState(1);

  const flexTypes = [
    {
      id: 1,
      title: "Normal Flex",
      icon: "📋",
      description: "Versatile flex material for all signage needs. Excellent durability and vibrant colors for both indoor and outdoor applications.",
      features: [
        "UV resistant coating",
        "Weatherproof protection",
        "Easy installation",
        "High-resolution printing",
        "Multiple finish options",
        "510 GSM optimal thickness"
      ],
      specifications: {
        material: "PVC flex banner",
        thickness: "510 GSM",
        width: "Up to 5m",
        durability: "3-5 years outdoor",
        applications: "Shop fronts, banners, events"
      },
      image: "https://images.unsplash.com/photo-1594736797933-d0401ba2fe65?w=500&h=350&fit=crop",
      color: "#4f46e5",
      bestFor: ["Retail signs", "Event banners", "Promotions", "Construction sites"],
      portfolio: {
        gallery: [
          "https://images.unsplash.com/photo-1594736797933-d0401ba2fe65?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1579546929662-711aa81148cf?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1560472355-536de3962603?w=400&h=300&fit=crop",
        ]
      }
    },
    {
      id: 2,
      title: "Star Flex",
      icon: "⭐",
      description: "Premium flex with elegant star finish for luxury branding. Creates sophisticated shimmer effects perfect for high-end retail and corporate applications.",
      features: [
        "Premium star-finish surface",
        "Enhanced color vibrancy",
        "Scratch-resistant coating",
        "360° optimal viewing",
        "Luxury matte finish",
        "600 GSM heavy-duty construction"
      ],
      specifications: {
        material: "Premium PVC with star finish",
        thickness: "600 GSM",
        width: "Up to 3.2m",
        durability: "5+ Yrs In /3+ Yrs Outdoor",
        applications: "Luxury retail, corporate branding"
      },
      image: "https://images.unsplash.com/photo-1579546929662-711aa81148cf?w=500&h=350&fit=crop",
      color: "#f59e0b",
      bestFor: ["Luxury stores", "Corporate offices", "Showrooms", "High-end events"],
      portfolio: {
        gallery: [
          "https://images.unsplash.com/photo-1518837695005-2083093ee35b?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1609921212029-bb5a28e60960?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1609921140401-e21688ae4309?w=400&h=300&fit=crop",
        ]
      }
    },
    {
      id: 3,
      title: "Black Back Flex",
      icon: "🔲",
      description: "Professional backlit signage material with black backing. Prevents light bleed for vibrant colors under illumination.",
      features: [
        "100% light-blocking backing",
        "Enhanced color contrast",
        "LED & fluorescent compatible",
        "Heat-resistant (60°C)",
        "Anti-curl technology",
        "550 GSM professional grade"
      ],
      specifications: {
        material: "PVC with black backing",
        thickness: "550 GSM",
        width: "Up to 3.5m",
        durability: "4+ years continuous",
        applications: "Backlit signage, lightboxes"
      },
      image: "https://images.unsplash.com/photo-1518837695005-2083093ee35b?w=500&h=350&fit=crop",
      color: "#057b80ff",
      bestFor: ["Store signs", "Airport displays", "Shopping malls", "24/7 signage"],
      portfolio: {
        gallery: [
          "https://images.unsplash.com/photo-1518837695005-2083093ee35b?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1609921212029-bb5a28e60960?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1609921140401-e21688ae4309?w=400&h=300&fit=crop",
        ]
      }
    },
    {
      id: 4,
      title: "Backlight Flex",
      icon: "💡",
      description: "Translucent flex for backlit applications. Optimal light diffusion with energy efficiency and vibrant colors.",
      features: [
        "70% light transmission",
        "Energy-efficient design",
        "Even light distribution",
        "Heat-resistant (70°C)",
        "Quick tensioning system",
        "480 GSM optimal weight"
      ],
      specifications: {
        material: "Translucent PVC",
        thickness: "480 GSM",
        width: "Up to 5m",
        durability: "5+ years maintained",
        applications: "Backlit displays, lightboxes"
      },
      image: "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?w=500&h=350&fit=crop",
      color: "#3b82f6",
      bestFor: ["24/7 signage", "Gas stations", "Fast food", "Corporate sites"],
      portfolio: {
        gallery: [
          "https://images.unsplash.com/photo-1518837695005-2083093ee35b?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1609921212029-bb5a28e60960?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1609921140401-e21688ae4309?w=400&h=300&fit=crop",
        ]
      }
    }
  ];

  return (
    <div className="flex-printing-page">
      <HeroSection 
        heroTitle="Flex Printing Services"
        heroSubtitle="Transform your brand with our premium flex printing solutions. From standard signage to specialized backlit displays, we deliver quality that stands out."
        onExploreClick={() => {
          const servicesSection = document.querySelector('.services-section');
          if (servicesSection) {
            servicesSection.scrollIntoView({ behavior: 'smooth' });
          }
        }}
        onGetQuoteClick={() => {
          const contactSection = document.getElementById('contact');
          if (contactSection) {
            contactSection.scrollIntoView({ behavior: 'smooth' });
          }
        }}
      />

      <FlexServicesSection flexTypes={flexTypes} />

      <FlexPortfolio 
        activeSection={activeSection}
        portfolioData={flexTypes.map(flexType => ({
          id: flexType.id,
          title: flexType.title,
          icon: flexType.icon,
          gallery: flexType.portfolio?.gallery || []
        }))}
        title="Our Flex Printing Portfolio"
        subtitle="Explore our premium flex printing services and see the quality that sets us apart"
      />
    </div>
  );
};

export default FlexPrinting;
